var isMobile = null;
var maxMobilWidth = 768;

function adjustSizeOfSoMeIframeBasedOnContent(t) {
    //default max iframe size for blocktype where SoMe block is displayed in the top, if height larger, adjust margin in top 
    var defTop = 450; 
    //default max iframe size for blocktype where SoMe block is displayed in the bottom, if height larger, adjust margin in bottom
    var defBottom = 500;
    var diff = 60;
    
    var newHeight = t.contentWindow.document.body.offsetHeight + 30;
    t.style.height = newHeight + 'px';

    var blockDiv = t.closest('div.some-post-block');
    var classNames = blockDiv.className;
    var a = classNames.split("__");
    var blockType = a[a.length - 1];

    /*
     blocktype is the Island design selected for block, and defines how the SoMe iframe is displayed. On the top or in the bottom of the block.
    */

    switch (blockType.trim()) {
        case "1": //Island design Øy 1, iframe in bottom on small screen
        case "3": //Island design Øy 3, iframe in bottom on small screen
            var marginBottom = newHeight - defBottom + diff;
            if (marginBottom > diff && window.innerWidth < maxMobilWidth) {
                blockDiv.style.marginBottom = marginBottom + "px";
            } else {
                blockDiv.style.marginBottom = null;
            }
            break;

        case "2": //Island design Øy 2, iframe in top on small screen
        case "4": //Island design Øy 4, iframe in top on small screen
            var marginTop = newHeight - defTop + diff;
            if (marginTop > diff && window.innerWidth < maxMobilWidth) {
                blockDiv.style.marginTop = marginTop + "px";
            } else {
                blockDiv.style.marginTop = null;
            }
            break;

    }
}

function reloadFrames() {
    var iframes = $('.some-post-block__iframe');
    for (var i = 0; i < iframes.length; i++) {
        iframes[i].src = iframes[i].src;
    }
} 

(function ($) {
    $('.some-post-block__iframe').load(function () {
        var c = this;

        setTimeout(function () {
            adjustSizeOfSoMeIframeBasedOnContent(c);
        }, 1000);
        
    });

    $(window).bind('resize',
        function () {
            //-- Set screen mode based on window size if isMobile is null ---//
            if (isMobile == null) {
                isMobile = ($(window).width() <= maxMobilWidth) ? true : false;
            }
            //-- Reload iFrames if resize into mobile mode and is not mobile ---//
            if ($(window).width() <= maxMobilWidth && !isMobile) {
                isMobile = true;
                reloadFrames();
            }
            //-- Reload iFrames if resize into desktop mode and is not desktop ---//
            else if ($(window).width() > maxMobilWidth && isMobile) {
                isMobile = false;
                reloadFrames();
            }
        });
})(jQuery);